export const ApprovalStatus = {
    NONE: 0,
    APPROVED: 1,
    REJECTED: 2
}